import { Theme } from '@mui/material/styles';
import {radioClasses} from "@mui/material";

// ----------------------------------------------------------------------

export function radio(theme: Theme) {
  return {
    // CHECKBOX, RADIO, SWITCH
    MuiFormControlLabel: {
      styleOverrides: {
        root: {
          marginLeft: 0
        },
        label: {
          ...theme.typography.body2,
        },
      },
    },

    MuiRadio: {
      styleOverrides: {
        root: {
          padding: '0px',
          paddingRight: theme.spacing(1),
          color: theme.palette.eliga_EDA.main,
          [`&.${radioClasses.checked}`]: {
            color: theme.palette.eliga_2EC.main,
          },
        },
      },
    },
  };
}
